import { useSessionData } from '@confluence/session-data';

export const useIsEmbedFeatureEnabled = () => {
	const { featureFlagClient } = useSessionData();
	return featureFlagClient.getBooleanValue('confluence.frontend.embeds.enabled', {
		default: false,
		shouldTrackExposureEvent: true,
	});
};
